export default {
  ADD_USER_LESSONS (state, userLessons) {
    state.userLessons = [...state.userLessons, ...userLessons]
  },
}
